// extracted by mini-css-extract-plugin
export var dataCell = "_ok-2";
export var dataRow = "_ok-0";
export var headerRow = "_ok-1";